import { render, staticRenderFns } from "./GrmTabs.vue?vue&type=template&id=7208781a&"
import script from "./GrmTabs.vue?vue&type=script&lang=js&"
export * from "./GrmTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7208781a')) {
      api.createRecord('7208781a', component.options)
    } else {
      api.reload('7208781a', component.options)
    }
    module.hot.accept("./GrmTabs.vue?vue&type=template&id=7208781a&", function () {
      api.rerender('7208781a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/tabs/GrmTabs.vue"
export default component.exports